import { useMutation } from 'react-query';

import api from '@root/api/newApi';

const getFraseKeywords = (queryObj) => api.frase.generateKeywords(queryObj);

const useFraseKeywords = () => useMutation((queryObj) => getFraseKeywords(queryObj));

export default useFraseKeywords;
